// Reklamační formulář + Odstoupení ve lhůtě 14 dní (issue #38,
// screens/15-reklamace.md, 16-odstoupeni.md + m15/m16; mockupy
// design/„Reklamační formulář(.mobil).dc.html" a „Odstoupení 14 dní(.mobil).dc.html").
//
// Sesterské stránky: stejná kostra (hero → checklist → portál + aside), liší se
// obsahem. Vyřízení běží přes **Retino** — do obsahu z administrace je vložený
// kontejner `div[id^=retino-portal-]` a inline injektor, který do něj za běhu
// vsadí `<iframe>`. Iframe NELZE stylovat zevnitř: stavíme jen OBAL a kontejner
// do něj PŘESOUVÁME (kopie by injektor odstřihla od jeho `id`).
//
// Checklist i odkaz na reklamační řád / obchodní podmínky čteme z reálného
// obsahu stránky (odstavec + `ul`), popisky dlaždic dodává návrh.
//
// KDE SE IFRAME VSAZUJE — varianta (a): kontejner Retina ADOPTUJEME (DR U6 / J1, #113)
//
// Injektor `cdn.retino.com/embeddedFormInjector.js` staví iframe vždy do
// `div#retino-portal-container<rootId>`, který přidává jako PŘÍMÉ DÍTĚ `<body>`
// (`position:absolute`), a jeho `top/left/width` dopočítává z vlastní vzpěry
// `#retino-portal-placeholder<rootId>` uvnitř našeho kontejneru
// (`repositionPortal()`). Do `.bs-ret__frame` se tedy iframe sám nikdy
// nedostane — původní `watchPortal` hlídal jen rámeček, po 8 s proto VŽDY
// nasadil `is-failed` a obě stránky jely v chybovém stavu, i když portál nad
// kartou kreslil (ověřeno na dev: `is-failed` + `frameHasIframe:false`).
//
// Vybráno (a) „adoptovat kontejner do rámečku" místo (b) „nechat kreslit
// v `<body>` a obal dorovnat výškou":
//   • geometrie je pak naše. Absolutní kontejner drží souřadnice z posledního
//     `repositionPortal()`, a ten se pouští jen z ResizeObserveru nad `<body>`
//     a z MutationObserveru na ATRIBUTY — ne na přesun uzlu. Po našem
//     přeskládání obsahu je poloha snadno zastaralá (na desktopu o 24 px, na
//     mobilu o výšku celého bloku).
//   • v toku nemůže přetéct stránku — uložené `left/width` z 390px renderu
//     přetékaly na 360px viewportu vodorovně ven.
//   • kontrola je jednoznačná: iframe JE potomek `.bs-ret__frame`, ne „leží
//     náhodou nad ním" (paritní snímek tenhle nález neodhalil, DOM ano).
// Cena: přesun kontejneru iframe jednou znovu načte (děje se při bootu, kdy
// v něm uživatel ještě nic nemá) a absolutní pozicování musíme vypnout CSS
// `!important` (`_retino.scss`) — VYJMA modálního stavu
// `.retino-open-modal-overlay` (`position:fixed` přes celé okno), o který si
// iframe říká zprávou `displayModal`. Vzpěra po adopci výšku jen zdvojuje,
// ve stavech `is-loaded`/`is-failed` ji proto CSS schová.
//
// ODCHYLKY OD SPECKY (ověřeno na dev instanci 2026-07-29):
//   • Design má u „Čísla objednávky" formát „JP-2026-XXXXX" — takový formát
//     nikde neověříme, dlaždice proto říká, kde číslo najít.
//   • CTA „Zahájit reklamaci online" drží placeholder v OBOU stavech (návrh ho
//     má i v načítacím) — míří na samostatný portál Retina, který se skládá
//     z `data-*` atributů kontejneru. Chybový stav k němu přidává e-mail jako
//     druhou cestu, ne jako jedinou.

import { icon } from './icon.js';
import { CONTACT } from './headerTools.js';
import {
  el,
  link,
  textOf,
  iconBox,
  pageHost,
  pageIs,
  markReady,
  buildHero,
  buildCheckCard,
  buildTimeline,
  buildLinkCard,
  buildHelpCard,
} from './infoPage.js';
import L from '../locale/cs/retinoPage.js';

const LABEL_RETINO = L.labelRetino;
const LABEL_LOADING_SUB = L.labelLoadingSub;
const LABEL_FAIL_TITLE = L.labelFailTitle;
const LABEL_FAIL_TEXT = L.labelFailText;
const LABEL_FAIL_CTA = L.labelFailCta;

// Injektor Retina — ID schéma (`ELEMENT_*_ID` + `rootId` kontejneru z administrace)
const RET_CONTAINER = 'retino-portal-container';
const RET_PORTAL_PATH = '/portal/iframe/';
const PORTAL_TIMEOUT = 8000;

// Popisky dlaždic checklistu podle klíčových slov v obsahu
const CHECK_MAP = L.checkMap;

const PAGES = L.pages;

// ---------------------------------------------------------------------------
// Parsování obsahu z administrace
// ---------------------------------------------------------------------------
function parseChecklist(host) {
  const list = host.querySelector('ul');
  if (!list) return [];
  const items = [];
  list.querySelectorAll(':scope > li').forEach(function (li) {
    const raw = textOf(li);
    if (!raw) return;
    let def = null;
    for (let i = 0; i < CHECK_MAP.length; i += 1) {
      if (CHECK_MAP[i].re.test(raw)) {
        def = CHECK_MAP[i];
        break;
      }
    }
    const title = def ? def.title : raw;
    // co v obsahu přebývá nad kanonickým titulkem, je popisek („uvedené v objednávce")
    const extra = raw.length > title.length && raw.toLowerCase().indexOf(title.toLowerCase()) === 0
      ? raw.slice(title.length).replace(/^[\s,–-]+/, '')
      : '';
    items.push({
      icon: def ? def.icon : 'check',
      title: title,
      desc: extra || (def ? def.desc : null),
    });
  });
  return items;
}

// Odkaz na reklamační řád / obchodní podmínky = jediný vnitřní odkaz v textu
function parseDocLink(host) {
  const anchors = host.querySelectorAll('p a[href]');
  for (let i = 0; i < anchors.length; i += 1) {
    const href = anchors[i].getAttribute('href') || '';
    if (/^https?:|^mailto:|^tel:/i.test(href)) continue;
    return href;
  }
  return null;
}

function findPortal(host) {
  return host.querySelector('[id^="retino-portal-"]:not([id*="placeholder"]):not([id*="footer"])');
}

// Samostatná adresa portálu = přesně ta, kterou si injektor dává do iframu
// (`{data-base-url}/{jazyk}/portal/iframe/{companyId}/`). Jiná veřejná URL
// portálu neexistuje — `/portal/{companyId}/` vrací 404 (ověřeno 2026-08-14).
function portalUrl(portal) {
  if (!portal) return null;
  const base = (portal.getAttribute('data-base-url') || '').replace(/\/+$/, '');
  const company = portal.getAttribute('data-company-id');
  if (!base || !company) return null;
  const lang = portal.getAttribute('data-language') || 'cs';
  const forms = portal.getAttribute('data-form-ids');
  return (
    base + '/' + lang + RET_PORTAL_PATH + company + '/'
    + (forms ? '?form-ids=' + encodeURIComponent(forms) : '')
  );
}

// Kontejner z administrace nese „&nbsp;" z editoru — v našem rámečku by z něj
// nad iframem zbyl mrtvý řádek (na dev přesně 24 px).
function stripFiller(node) {
  const kids = node.childNodes;
  for (let i = kids.length - 1; i >= 0; i -= 1) {
    const kid = kids[i];
    // pozor: JS `\s` pokrývá i nezlomitelnou mezeru (U+00A0), jiný test netřeba
    if (kid.nodeType === 3 && !(kid.nodeValue || '').replace(/\s+/g, '')) {
      node.removeChild(kid);
    }
  }
}

// ---------------------------------------------------------------------------
// Stavba
// ---------------------------------------------------------------------------
function buildStat(def) {
  const card = el('div', 'bs-ret__stat');
  card.appendChild(icon('refresh', 'bs-ret__stat-deco'));
  const top = el('div', 'bs-ret__stat-top');
  top.appendChild(el('span', 'bs-ret__stat-num', def.num));
  top.appendChild(el('span', 'bs-ret__stat-unit', def.unit));
  card.appendChild(top);
  card.appendChild(el('div', 'bs-ret__stat-sub', def.sub));
  card.appendChild(el('span', 'bs-ret__stat-rule'));
  const list = el('div', 'bs-ret__stat-list');
  def.points.forEach(function (text) {
    const row = el('span', 'bs-ret__stat-point');
    row.appendChild(icon('check'));
    row.appendChild(el('span', null, text));
    list.appendChild(row);
  });
  card.appendChild(list);
  return card;
}

// CTA do portálu — návrh ho má v placeholderu v OBOU stavech (m15/m16 §3)
function buildPortalCta(cfg, href) {
  const cta = link(href, 'bs-ip__cta bs-ip__cta--primary bs-ret__ph-cta bs-ret__ph-cta--portal');
  cta.target = '_blank';
  cta.rel = 'noopener';
  cta.appendChild(icon(cfg.portalIcon));
  cta.appendChild(el('span', null, cfg.portalCta));
  return cta;
}

function buildMailCta() {
  const cta = link('mailto:' + CONTACT.email, 'bs-ip__cta bs-ip__cta--outline bs-ret__ph-cta bs-ret__ph-cta--mail');
  cta.appendChild(icon('mail'));
  cta.appendChild(el('span', null, LABEL_FAIL_CTA));
  return cta;
}

function buildCtaRow(items) {
  const row = el('div', 'bs-ret__ph-ctas');
  items.forEach(function (node) {
    if (node) row.appendChild(node);
  });
  return row;
}

function buildPortalCard(cfg, portal) {
  const card = el('section', 'bs-ret__portal');
  const href = portalUrl(portal);

  const head = el('div', 'bs-ret__portal-head');
  head.appendChild(iconBox(cfg.portalIcon, 'bs-ret__portal-icon'));
  const title = el('div', 'bs-ret__portal-titles');
  title.appendChild(el('div', 'bs-ret__portal-title', cfg.portalTitle));
  title.appendChild(el('div', 'bs-ret__portal-sub', cfg.portalSub));
  head.appendChild(title);
  const pill = el('span', 'bs-ret__pill');
  pill.appendChild(el('span', 'bs-ret__pill-dot'));
  pill.appendChild(el('span', null, LABEL_RETINO));
  head.appendChild(pill);
  card.appendChild(head);

  const body = el('div', 'bs-ret__portal-body');
  const frame = el('div', 'bs-ret__frame');
  if (portal) {
    stripFiller(portal);
    frame.appendChild(portal); // PŘESUN, ne kopie — injektor drží `id`
  }
  body.appendChild(frame);

  const ph = el('div', 'bs-ret__ph');
  ph.appendChild(iconBox(cfg.portalIcon, 'bs-ret__ph-icon'));
  const load = el('div', 'bs-ret__ph-state bs-ret__ph-state--load');
  load.appendChild(el('div', 'bs-ret__ph-title', cfg.portalLoading));
  load.appendChild(el('p', 'bs-ret__ph-text', cfg.portalLoadingText));
  if (href) load.appendChild(buildCtaRow([buildPortalCta(cfg, href)]));
  ph.appendChild(load);
  const fail = el('div', 'bs-ret__ph-state bs-ret__ph-state--fail');
  fail.appendChild(el('div', 'bs-ret__ph-title', LABEL_FAIL_TITLE));
  fail.appendChild(el('p', 'bs-ret__ph-text', LABEL_FAIL_TEXT));
  // chybová větev nabízí portál i e-mail — mailto samo je slepá ulička
  fail.appendChild(buildCtaRow([href ? buildPortalCta(cfg, href) : null, buildMailCta()]));
  ph.appendChild(fail);
  ph.appendChild(el('div', 'bs-ret__ph-note', LABEL_LOADING_SUB));
  body.appendChild(ph);

  card.appendChild(body);
  return { card: card, frame: frame };
}

// Kontejner s iframem hledáme v CELÉM dokumentu — injektor ho vsazuje do
// `<body>`, ne do našeho rámečku (viz rozhodnutí nahoře).
function findInjected(portal) {
  const byId = portal && portal.id ? document.getElementById(RET_CONTAINER + portal.id) : null;
  return byId || document.querySelector('.' + RET_CONTAINER);
}

// Adopce portálu: co injektor pověsí na `<body>`, přebíráme do rámečku.
// Placeholder mizí, až iframe doopravdy je.
function watchPortal(card, frame, portal) {
  let failTimer = 0;

  const settle = function () {
    const box = findInjected(portal);
    if (!box || !box.querySelector('iframe')) return false;
    // kontejner jde PŘED náš (v něm zůstává jen vzpěra a petit „Používáme Retino")
    if (box.parentNode !== frame) frame.insertBefore(box, frame.firstChild);
    if (failTimer) {
      window.clearTimeout(failTimer);
      failTimer = 0;
    }
    card.classList.remove('is-failed');
    card.classList.add('is-loaded');
    return true;
  };

  if (!settle()) {
    failTimer = window.setTimeout(function () {
      failTimer = 0;
      if (!settle()) card.classList.add('is-failed');
    }, PORTAL_TIMEOUT);
  }

  if (!window.MutationObserver) return;
  // Observer NEODPOJUJEME: `reloadIframe()` v injektoru kontejner smaže a vyrobí
  // nový — zase v `<body>` —, takže adopci musíme držet po celou dobu stránky.
  const observer = new MutationObserver(function () {
    settle();
  });
  observer.observe(document.body, { childList: true });
}

// ---------------------------------------------------------------------------
export function initRetinoPage() {
  let cfg = null;
  for (let i = 0; i < PAGES.length; i += 1) {
    if (pageIs(PAGES[i].page)) cfg = PAGES[i];
  }
  if (!cfg) return;

  const host = pageHost();
  if (!host || document.querySelector('.bs-ret')) return;

  const items = parseChecklist(host.about);
  const docHref = parseDocLink(host.about);
  const portal = findPortal(host.about);
  if (!items.length && !portal) return; // obsah neodpovídá — necháme nativní text

  const root = el('div', 'bs-ip bs-ret');
  root.appendChild(
    buildHero(
      {
        eyebrow: cfg.eyebrow,
        title: host.h1 || null,
        perex: cfg.perex,
      },
      cfg.stat ? buildStat(cfg.stat) : null
    )
  );

  if (items.length) root.appendChild(buildCheckCard(cfg.checkTitle, items));

  const grid = el('div', 'bs-ret__grid');
  const built = buildPortalCard(cfg, portal);
  grid.appendChild(built.card);

  const side = el('aside', 'bs-ret__side');
  side.appendChild(buildTimeline(cfg.stepsTitle, cfg.steps));
  if (docHref) {
    side.appendChild(buildLinkCard({ href: docHref, title: cfg.linkTitle, desc: cfg.linkDesc }));
  }
  side.appendChild(buildHelpCard({ title: cfg.helpTitle, text: cfg.helpText, email: CONTACT.email }));
  grid.appendChild(side);
  root.appendChild(grid);

  host.about.classList.add('bs-ip__native');
  host.about.insertAdjacentElement('beforebegin', root);
  watchPortal(built.card, built.frame, portal);
  markReady();
}
